module.exports = __webpack_public_path__ + "img/show_tc_text_8.6dcfb388.png";